export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/service-panel.110d7214-f61119.svg";